import { format } from "date-fns";
import { it } from 'date-fns/locale/it';
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { LogoSpinnerComponent } from "../../lib/spinner/spinnerLogo";
import { colors } from "../../ui/colors";
import { ArrowLeftIcon } from "../../ui/icons/arrow-left";
import { Layout } from "../../ui/layout";
import { CustomAccordion } from '../../ui/molecules/accordion';
import { ButtonComponent } from "../../ui/molecules/button/newButton";
import { Calendar } from "../../ui/molecules/calendar";
import { MadfarmInput } from "../../ui/molecules/input/newInput";
import RadioButtonGroup from "../../ui/molecules/RadioButtonGroup";
import { MadfarmStaticSelect } from "../../ui/molecules/select/newSelect/static";
import { ErrorPopup } from "../../ui/organisms/errorPopup";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { RightBar } from "../../ui/organisms/rightBar";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import { mapRole, officeOptions, OptionType, role, sot } from "../../utils";
import { GetByIdAnagraphic, resetGetByIdStatus } from "../gestionePersonale/boxAnagrafica/slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../gestionePersonale/slice";
import { GetHeadQuarter, resetGetAllSot } from "../sot/slice";
import { ActivateUser, editUser, findUserById, resetEditUserStatusIdle, resetUserActivationStatus, resetUserValidationStatus, setActivationDate, setDeActivationDate, setEmail, setFiscalCode, setHeadQuarter, setIsMeasuresSignature, setName, setOffice, setOfficeProt, setPec, setPhone, setPMId, setRole, setSotProt, setSurname, setUsername, UserValidation } from "./slice";
import './style.scss';

registerLocale('it', it)

enum SotProtOptionsCode {
    SI = 'SI',
    NO = 'NO',
}

enum OfficeProtOptionsCode {
    SI = 'SI',
    NO = 'NO',
}

enum OptionYesOrNot {
    SI = 'SI',
    NO = 'NO',
}

export function EditUser() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const anagraficaState = useAppSelector(state => state.PMAnagrafica)
    const usersState = useAppSelector(state => state.users)
    const sotState = useAppSelector(state => state.headQuarter)

    const [selectedOptionOfficeProt, setSelectedOptionOfficeProt] = useState<OfficeProtOptionsCode | null>(null)
    const [selectedOptionSotProt, setSelectedOptionSotProt] = useState<SotProtOptionsCode | null>(null)
    const [selectedIsMeasureSignature, setSelectedIsMeasureSignature] = useState<OptionYesOrNot | null>(null)
    const [onClientActivate, setOnClientActivate] = useState<boolean>(false)
    const [personalResources, setPersonalResources] = useState<OptionType[]>([])
    const [headquarter, setHeadquarters] = useState<OptionType[]>([])
    const [roleTable, setRoleTable] = useState('')
    const [roleRegione, setRoleRegione] = useState('')
    const [roleNorma, setRoleNorma] = useState('')
    const [expanded, setExpanded] = useState<Record<string, boolean>>({
        panel1: true,
        panel2: true,
    })

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => ({
            ...prev,
            [panel]: !prev[panel],
        }))
    }

    useEffect(() => {
        if (usersState.selectedUserId) {
            dispatch(findUserById(usersState.selectedUserId))
        }
        dispatch(GetAllPersonalManagement({}))
        dispatch(GetHeadQuarter(sotState.sotFilters))
    }, [])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully' && sotState.responseHeadQuarter) {
            const data = sotState.responseHeadQuarter.data
            const newObjects: OptionType[] = data.map(d => ({ value: d.id, label: `${d.code}` }))
            setHeadquarters(newObjects)
            dispatch(resetGetAllSot())
        }
    }, [sotState.responseHeadQuarterStatus])

    useEffect(() => {
        if (usersState.userValidationStatus === 'successfully') {
            dispatch(resetUserValidationStatus())
            if (onClientActivate) {
                dispatch(ActivateUser({ id: usersState.selectedUserId, data: usersState.usersEditCreateRequest }))
            } else {
                dispatch(editUser({ id: usersState.selectedUserId, data: usersState.usersEditCreateRequest }))
            }
        }
    }, [usersState.userValidationStatus])

    useEffect(() => {
        if (usersState.userActivationStatus === 'successfully') {
            setOnClientActivate(false)
            dispatch(resetUserActivationStatus())
            dispatch(editUser({ id: usersState.selectedUserId, data: usersState.usersEditCreateRequest }))
        }
    }, [usersState.userActivationStatus])

    useEffect(() => {
        if (usersState.findUserByIdStatus === 'successfully' && usersState.findUserByIdResponse) {
            if (usersState.findUserByIdResponse.username === null && usersState.findUserByIdResponse.email === null) {
                setOnClientActivate(true)
            }

            dispatch(setName(usersState.findUserByIdResponse.name))
            dispatch(setSurname(usersState.findUserByIdResponse.surname))
            dispatch(setEmail(usersState.findUserByIdResponse.email))
            dispatch(setUsername(usersState.findUserByIdResponse.username))
            dispatch(setPhone(usersState.findUserByIdResponse.phone))
            dispatch(setRole(usersState.findUserByIdResponse.role))
            dispatch(setOffice(usersState.findUserByIdResponse.office))
            dispatch(setPMId(usersState.findUserByIdResponse.personalManagementId))
            dispatch(setPec(usersState.findUserByIdResponse.pec))
            dispatch(setFiscalCode(usersState.findUserByIdResponse.fiscalCode))
            dispatch(setHeadQuarter(usersState.findUserByIdResponse.headQuarterInfo.id))
            dispatch(setActivationDate(usersState.findUserByIdResponse.activationDate))
            dispatch(setDeActivationDate(usersState.findUserByIdResponse.deactivationDate))
            dispatch(setOfficeProt(usersState.findUserByIdResponse.managementProtocolOffice))
            dispatch(setSotProt(usersState.findUserByIdResponse.managementProtocolHeadQuarter))

            setSelectedOptionOfficeProt(
                usersState.findUserByIdResponse.managementProtocolOffice ? OfficeProtOptionsCode.SI : OfficeProtOptionsCode.NO
            )
            setSelectedOptionSotProt(
                usersState.findUserByIdResponse.managementProtocolHeadQuarter ? SotProtOptionsCode.SI : SotProtOptionsCode.NO
            )
            setSelectedIsMeasureSignature(
                usersState.findUserByIdResponse.isMeasuresSignature ? OptionYesOrNot.SI : OptionYesOrNot.NO
            )
        }
    }, [usersState.findUserByIdStatus, usersState.findUserByIdResponse])

    useEffect(() => {
        const currentRole = usersState.usersEditCreateRequest.role
        if (!currentRole) {
            setRoleTable('')
            setRoleRegione('')
            setRoleNorma('')
            return
        }

        mapRole
            .filter(({ role }) => role === currentRole)
            .forEach(el => {
                setRoleTable(el.label)
                setRoleRegione(el.regioni)
                setRoleNorma(el.normativa)
            })
    }, [usersState.usersEditCreateRequest.role])

    useEffect(() => {
        if (
            personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            personalManagementState.getAllPersonalManagementResourcesResponse.data.forEach(pm => {
                if (pm.anagraphicId !== null) {
                    dispatch(GetByIdAnagraphic(String(pm.anagraphicId)))
                }
            })
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (
            anagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            anagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))
            const data = anagraficaState.getByIdAnagraphicRequest
            const newPR: OptionType = { label: `${data.name} ${data.surname}`, value: data.personalManagementId }
            setPersonalResources(prev => {
                if (prev.some(pr => pr.value === newPR.value)) {
                    return prev
                }
                return [...prev, newPR]
            })
        }
    }, [anagraficaState.GetByIdAnagraphicStatus])

    const handleOptionOfficeProtChange = (value: OfficeProtOptionsCode) => {
        setSelectedOptionOfficeProt(value)
        dispatch(setOfficeProt(value === 'SI'))
    }

    const handleOptionSotProtChange = (value: SotProtOptionsCode) => {
        setSelectedOptionSotProt(value)
        dispatch(setSotProt(value === 'SI'))
    }

    const handleOptionIsMeasureSignature = (value: OptionYesOrNot) => {
        setSelectedIsMeasureSignature(value)
        dispatch(setIsMeasuresSignature(value === 'SI'))
    }

    if (usersState.findUserByIdStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout
            menuItem={MenuItems.USERS}
            breadcrumbItems={['Utenti', 'Modifica Utente']}
            headerLabel={`${usersState.findUserByIdResponse?.name || ''} ${usersState.findUserByIdResponse?.surname || ''}`.trim()}
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/users')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label={onClientActivate ? "Attiva e Modifica" : "Modifica"}
                        color={"orange"}
                        onClick={() => {
                            dispatch(UserValidation(usersState.usersEditCreateRequest))
                        }}
                    />
                </div>
            }
        >
            <div className="flex flex-col w-full h-full overflow-hidden">
                {(usersState.editUserStatus === 'successfully' || usersState.editUserStatus === 'failed') && (
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <SuccessPopup
                            active={usersState.editUserStatus === 'successfully'}
                            message="Dati salvati correttamente."
                            onClose={() => {
                                dispatch(resetEditUserStatusIdle())
                            }}
                        />
                        <ErrorPopup
                            active={usersState.editUserStatus === 'failed'}
                            message="Errore nel salvataggio."
                            onClose={() => {
                                dispatch(resetEditUserStatusIdle())
                            }}
                        />
                    </div>
                )}
                <div className="grid grid-cols-[minmax(0,7fr)_minmax(0,3fr)] flex-1 overflow-hidden overflow-x-hidden">
                    <div className="min-w-0 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200 p-6 flex flex-col gap-6">
                        <CustomAccordion
                            id="panel1"
                            title={<span className="text-uppercase text-white label-input">Credenziali</span>}
                            expanded={expanded.panel1}
                            onChange={() => handleToggleAccordion('panel1')}
                            detailsClassName="flex flex-col gap-4"
                        >
                            <div className="grid grid-cols-1 gap-4">
                                <MadfarmInput
                                    label={'Username'}
                                    error={usersState.createUserErrors.username}
                                    supportingText={usersState.createUserErrors.username ? 'Username mancante' : undefined}
                                    disabled={!!usersState.findUserByIdResponse?.username}
                                    placeholder="Username"
                                    onChangeText={(text) => dispatch(setUsername(text))}
                                    value={usersState.usersEditCreateRequest.username}
                                />
                            </div>
                        </CustomAccordion>

                        <CustomAccordion
                            id="panel2"
                            title={<span className="text-uppercase text-white label-input">Anagrafica</span>}
                            expanded={expanded.panel2}
                            onChange={() => handleToggleAccordion('panel2')}
                            detailsClassName="flex flex-col gap-4"
                        >
                            <div className="grid grid-cols-3 gap-4">
                                <MadfarmInput
                                    label={'Nome'}
                                    placeholder="Nome"
                                    error={usersState.createUserErrors.name}
                                    supportingText={usersState.createUserErrors.name ? 'Nome mancante' : undefined}
                                    onChangeText={(text) => dispatch(setName(text))}
                                    value={usersState.usersEditCreateRequest.name}
                                />
                                <MadfarmInput
                                    label={'Cognome'}
                                    placeholder="Cognome"
                                    error={usersState.createUserErrors.surname}
                                    supportingText={usersState.createUserErrors.surname ? 'Cognome mancante' : undefined}
                                    onChangeText={(text) => dispatch(setSurname(text))}
                                    value={usersState.usersEditCreateRequest.surname}
                                />
                                <MadfarmInput
                                    label={'Codice Fiscale'}
                                    placeholder="Codice Fiscale"
                                    error={usersState.createUserErrors.fiscalCode}
                                    supportingText={usersState.createUserErrors.fiscalCode ? 'Codice fiscale mancante (16 caratteri)' : undefined}
                                    onChangeText={(text) => dispatch(setFiscalCode(text))}
                                    value={usersState.usersEditCreateRequest.fiscalCode}
                                />
                            </div>

                            <div className="grid grid-cols-3 gap-4">
                                <MadfarmInput
                                    label={'Email'}
                                    placeholder="Email"
                                    disabled={!!usersState.findUserByIdResponse?.email}
                                    error={usersState.createUserErrors.email}
                                    supportingText={usersState.createUserErrors.email ? 'Email mancante' : undefined}
                                    onChangeText={(text) => dispatch(setEmail(text))}
                                    value={usersState.usersEditCreateRequest.email}
                                />
                                <MadfarmInput
                                    label={'PEC'}
                                    placeholder="PEC"
                                    onChangeText={(text) => dispatch(setPec(text))}
                                    error={usersState.createUserErrors.pec}
                                    supportingText={usersState.createUserErrors.pec ? 'Pec mancante' : undefined}
                                    value={usersState.usersEditCreateRequest.pec}
                                />
                                <MadfarmInput
                                    label={'Cellulare'}
                                    placeholder="Cellulare"
                                    error={usersState.createUserErrors.phone}
                                    supportingText={usersState.createUserErrors.phone ? 'Deve essere max 10 caratteri' : undefined}
                                    onChangeText={(text) => dispatch(setPhone(text))}
                                    value={usersState.usersEditCreateRequest.phone}
                                />
                            </div>
                        </CustomAccordion>
                    </div>

                    <div className="min-w-0 overflow-y-auto bg-white">
                        <RightBar>
                            <div className="flex flex-col gap-5 w-full">
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Sede<span className="text-red-500"> *</span></span>
                                    <MadfarmStaticSelect
                                        placeholder={'Sede'}
                                        error={usersState.createUserErrors.sot}
                                        errorLabel={'Sede mancante'}
                                        options={headquarter}
                                        value={usersState.usersEditCreateRequest.headQuarterId}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setHeadQuarter(newValue))
                                        }}
                                        noOptionsMessage={'Nessuna sede trovata'}
                                    />
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Ufficio</span>
                                    <MadfarmStaticSelect
                                        placeholder={'Ufficio'}
                                        options={officeOptions}
                                        value={usersState.usersEditCreateRequest.office}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setOffice(newValue))
                                        }}
                                        noOptionsMessage={'Nessun ufficio trovato'}
                                    />
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Personale</span>
                                    <MadfarmStaticSelect
                                        placeholder={'Personale'}
                                        value={usersState.usersEditCreateRequest.personalManagementId}
                                        options={personalResources}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setPMId(newValue))
                                        }}
                                        noOptionsMessage={'Nessun personale trovato'}
                                    />
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Ruolo<span className="text-red-500"> *</span></span>
                                    <MadfarmStaticSelect
                                        placeholder={'Ruolo'}
                                        options={role}
                                        error={usersState.createUserErrors.role}
                                        errorLabel={'Ruolo mancante'}
                                        value={usersState.usersEditCreateRequest.role}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setRole(newValue))
                                        }}
                                        noOptionsMessage={'Nessun ruolo trovato'}
                                    />
                                </div>

                                <div className="rounded-xl border border-neutral-200 bg-neutral-50">
                                    <div className="grid grid-cols-[120px_1fr] border-b border-neutral-200">
                                        <div className="px-3 py-2 font-semibold text-brandPrimary-700">Ufficio</div>
                                        <div className="px-3 py-2 text-neutral-700">{roleTable}</div>
                                    </div>
                                    <div className="grid grid-cols-[120px_1fr] border-b border-neutral-200">
                                        <div className="px-3 py-2 font-semibold text-brandPrimary-700">Normativa</div>
                                        <div className="px-3 py-2 text-neutral-700">{roleNorma}</div>
                                    </div>
                                    <div className="grid grid-cols-[120px_1fr]">
                                        <div className="px-3 py-2 font-semibold text-brandPrimary-700">Regioni</div>
                                        <div className="px-3 py-2 text-neutral-700">{roleRegione}</div>
                                    </div>
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-2 text-center">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Data Attivazione</span>
                                    <Calendar
                                        selected={usersState.usersEditCreateRequest.activationDate}
                                        onChange={(date) => {
                                            dispatch(setActivationDate(format(new Date(date), 'yyyy-MM-dd')))
                                        }}
                                    />

                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600 mt-2">Data Disattivazione</span>
                                    <Calendar
                                        selected={usersState.usersEditCreateRequest.deactivationDate}
                                        onClear={(date) => dispatch(setDeActivationDate(date))}
                                        onChange={(date) => {
                                            dispatch(setDeActivationDate(format(new Date(date), 'yyyy-MM-dd')))
                                        }}
                                    />
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-2 text-left">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Firma Provvedimento</span>
                                    <RadioButtonGroup
                                        name={'is_measure_signature'}
                                        options={Object.values(OptionYesOrNot)}
                                        selectedValue={selectedIsMeasureSignature}
                                        onChange={handleOptionIsMeasureSignature}
                                        optionLabels={{
                                            [OptionYesOrNot.SI]: 'Si',
                                            [OptionYesOrNot.NO]: 'No',
                                        }}
                                    />
                                </div>

                                {(usersState.usersEditCreateRequest.headQuarterId || usersState.usersEditCreateRequest.office) && (
                                    <>
                                        <div className="border-t border-neutral-200" />
                                        <div className="flex flex-col gap-3 text-left">
                                            <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Gestione Protocollo</span>

                                            {usersState.usersEditCreateRequest.headQuarterId && (
                                                <div className="flex flex-col gap-2 text-left">
                                                    <span className="text-sm font-semibold text-neutral-700">
                                                        Sede: {
                                                            sot
                                                                .filter(({ value }) => value === usersState.usersEditCreateRequest.headQuarterId)
                                                                .map(el => el.label)
                                                                .join(', ')
                                                        }
                                                    </span>
                                                    <RadioButtonGroup
                                                        name={'prot_sot_able'}
                                                        options={Object.values(SotProtOptionsCode)}
                                                        selectedValue={selectedOptionSotProt}
                                                        onChange={handleOptionSotProtChange}
                                                        optionLabels={{
                                                            [SotProtOptionsCode.SI]: 'Si',
                                                            [SotProtOptionsCode.NO]: 'No',
                                                        }}
                                                    />
                                                </div>
                                            )}

                                            {usersState.usersEditCreateRequest.office && (
                                                <div className="flex flex-col gap-2 text-left">
                                                    <span className="text-sm font-semibold text-neutral-700">
                                                        Ufficio: {
                                                            officeOptions
                                                                .filter(({ value }) => value === usersState.usersEditCreateRequest.office)
                                                                .map(el => el.label)
                                                                .join(', ')
                                                        }
                                                    </span>
                                                    <RadioButtonGroup
                                                        name={'prot_office_able'}
                                                        options={Object.values(OfficeProtOptionsCode)}
                                                        selectedValue={selectedOptionOfficeProt}
                                                        onChange={handleOptionOfficeProtChange}
                                                        optionLabels={{
                                                            [OfficeProtOptionsCode.SI]: 'Si',
                                                            [OfficeProtOptionsCode.NO]: 'No',
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </RightBar>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
